// extracted by mini-css-extract-plugin
module.exports = {"container":"aftercare_container__-ELph","content":"aftercare_content__B_V3l","menuRow":"aftercare_menuRow__2PXdG"};